import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'ansyn-algorithms',
	templateUrl: './algorithms.component.html',
	styleUrls: ['./algorithms.component.less']
})
export class AlgorithmsComponent implements OnInit {

	constructor() {
	}

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/menu-items/algorithms/algorithms/algorithms.component.ts